<template>
    <div class="stepsdemo-content p-4">
        <i class="pi pi-fw pi-money-bill mb-4" />
        <p>Payment Component Content via Child Route</p>
    </div>
</template>

<script>
export default {};
</script>